import React from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import FormAssembly from "../../../components/FormAssembly/FormAssembly";
import store from "../../../store";
import {Helmet} from "react-helmet";

const emailPreferenceForm = () => {
  return (
    <div className="wrapper">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Manage" ? row.sections.map((section) => {
                        return section.title === "Forms & Applications" ? section.subsections.map((subsection) => {
                                    return subsection.title === "Email Preference Form" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                })
                                : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs/>
      <h1 className="two-three-rows__title">Email Preference Form</h1>
      <div className="iframe-box-wrapper">
        <FormAssembly formReferenceName="EMAIL_PREFERENCE_FORM"/>
      </div>
    </div>
  );
};

export default emailPreferenceForm;



// WEBPACK FOOTER //
// ./src/pages/manage/FormsAndApplications/EmailPreferenceForm.js